/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import api from '../../components/backend/backend-api'
import router from '../../router'


const state = { authenticated2:false, status:'', token: localStorage.getItem('user-token') || '' }

const getters = {
  isAuthenticated:state => !!state.token,
  isAuthenticatedNew:state => state.authenticated2,
  authStatus: state => state.status,
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      api.login({'username':user.username, 'password': user.password})
      .then(resp => {
        if(resp.headers.auth_error=='true') {
          state.authenticated2 = false
          reject(resp)
        } else {
          commit(AUTH_SUCCESS)
          dispatch(USER_REQUEST)
          resolve(resp)
        }

      })
      .catch(err => {
        alert("Auth error:"+ err)
        commit(AUTH_ERROR, err)
        state.authenticated2 = false
        reject(err)
      })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      api.logout().then(resp =>{
         commit(AUTH_LOGOUT)
        resolve()
    })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state) => {
    state.status = 'success'
    state.authenticated2 = true
    localStorage.setItem('user-token', 'authenticated')
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.authenticated2 = false
    localStorage.removeItem('user-token')
    router.push("/login")
  },
  [AUTH_LOGOUT]: (state) => {
    state.authenticated2 = false
    localStorage.removeItem('user-token')

  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
